import type { CheckboxChangeEvent } from 'antd';
import type { ChatGroupMember } from '@/contexts/chat/scripts/hooks/useChatGroup/types';
import type { SearchMembersList } from '@/components/search-members';

type Member = ChatGroupMember;

export function useSearchMembersState() {
  const [selectedMembers, setSelectedMembers] = useState<Member[]>([]);
  const membersList = useReactive<SearchMembersList>({
    contacts: [],
    members: [],
    users: [],
  });

  const allSelectedMembers = useMemo(() => {
    return [...membersList.contacts, ...membersList.members, ...membersList.users];
  }, [membersList.contacts, membersList.members, membersList.users]);

  const updateMembersList = useCallback(
    (list: SearchMembersList) => {
      membersList.contacts = list.contacts;
      membersList.members = list.members;
      membersList.users = list.users;
    },
    [membersList]
  );

  const onSelect = useCallback((item: Member[]) => {
    setSelectedMembers(item);
  }, []);

  const onMemberDelete = useCallback(
    (member: Member) => {
      setSelectedMembers(selectedMembers.filter((c) => c.user_id !== member.user_id));
    },
    [selectedMembers]
  );

  const onAllSelect = useCallback(
    (e: CheckboxChangeEvent) => {
      setSelectedMembers(e.target.checked ? allSelectedMembers : []);
    },
    [allSelectedMembers]
  );

  return {
    selectedMembers,
    setSelectedMembers,
    membersList,
    updateMembersList,
    onSelect,
    onMemberDelete,
    onAllSelect,
    allSelectedMembers,
  };
}
